<template>
  <v-main class="pa-4" fluid>
    <v-row >

      <v-snackbar v-model="alerta.activo" vertical top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>
      

      <v-col cols="12">
        <v-card  class="shadowCard" >

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold grey--text"> Cotizaciones </span>
	  		    <v-spacer></v-spacer>

	  		    <v-badge
			        bordered
			        color="error"
			        :content="carrito.length"
			        overlap
			        class="mr-6"
			      >
			        <v-btn
			        	@click="dialogCarrito = true"
			          class="white--text"
			          color="error"
			          depressed
			        >
        				<v-icon>mdi-shopping-outline</v-icon>
			        </v-btn>
			      </v-badge>

	  		    <v-btn color="green darken-1" outlined   @click="initialize()">
              <b>Actualizar</b>
            </v-btn>
	  		  </v-card-title>

          <v-card-text class="black--text">

          	<label class="">
          		Ingresa los datos del cliente
          	</label>

          	<v-row>
          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="nombre"
          				label="Nombre del cliente"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="nombre"
          				label="Apellidos del cliente"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="email"
          				label="Correo del cliente"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="telefono"
          				label="Teléfono del cliente"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="calle"
          				label="Calle"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="numint"
          				label="Número Int."
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="cp"
          				label="Código Postal"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="colonia"
          				label="colonia"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>

          		<v-col cols="12" md="6" lg="4">
          			<v-text-field
          				v-model="estado"
          				label="Estado"
          				filled
          				hide-details
          				dense
          			>
          			</v-text-field>
          		</v-col>
          	</v-row>

          	<v-divider class="my-4"></v-divider>

          	<v-row>
          		<!-- Productos -->
				      <v-col cols="12" sm="5" md="4" lg="3"  v-for="(item, i) in pedidos" :key="i">
				        <v-card class="lateral" outlined height="100%">
				          <!-- Descuento mostrado -->
				          <v-btn 
				            color="primary" 
				            absolute
				            top
				            left
				            class="v-btn--descuento text-caption"
				            x-small
				            rounded
				            v-if="item.pjedesc > 0"
				          >
				            {{ item.pjedesc }}% Descuento
				          </v-btn>

				          <!-- Ver el artículo -->
				          <v-btn 
				            icon
				            absolute
				            top
				            right
				            class="v-btn--descuento text-caption"
				            small
				            rounded
				          >
				            <v-icon color="black">mdi-eye</v-icon>
				          </v-btn>

				          <!-- IMAGEN PRINCIPAL -->
				          <v-img 
				            :src="url + item.foto" 
				            height="250px" 
				            contain 
				            v-if="item.foto"
				            class="white"
				            @click="cotizaArticulo(item)"

				          >
				          </v-img>
				          
				          <!-- SI NO HAY IMAGEN INCERTO DEFAULT-->
				          <v-img 
				            :src="`${url + photo}`" 
				            height="250px"
				            contain 
				            v-else 
				            color="secondary" 
				            @click="cotizaArticulo(item)"

				          />

				          <v-card-text class="pb-4" @click="cotizaArticulo(item)">
				            <v-row>
				              <v-col cols="12" class="pb-0">
				                <span class="text-subtitle-1 font-weight-bold">{{item.nomart}}</span>
				              </v-col>
				              <v-col cols="12" class="pt-0 pb-6">
				                <!-- Precio normal -->
				                <span v-if="item.pjedesc === 0"><h2 class="primary--text mr-2 mb-0"> {{ item.precio1 | currency(2) }} MX </h2></span>
				                <!-- Precio con descuento -->
				                <span v-else class="primary--text mr-2 mb-0"> 
				                  <h2 class="primary--text mr-2 mb-0">
				                    {{ (item.precio1) - (item.pjedesc / 100) * (item.precio1 ) | currency(2) }} MX
				                    <span class="text-decoration-line-through grey--text" v-if="item.pjedesc > 0"> 
				                      ${{ item.precio1 }} 
				                    </span>
				                  </h2> 
				                </span>
				              </v-col>
				            </v-row>

				          </v-card-text>
				        
				          <v-card-actions>
				            <v-btn 
				              color="primary" 
				              outlined
				              block
				              right
				              @click="cotizaArticulo(item)"
				            >
				            	Visualizar
				              <v-icon right>mdi-eye</v-icon>
				            </v-btn>
				            <v-spacer></v-spacer>
				          </v-card-actions>
				        </v-card>
				      </v-col>	
          	</v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <v-dialog
    	v-model="dialogCotizador"
    	max-width="1000"
    >
    	<v-card v-if="articuloAcotizar">
    		<v-card-title> Cotizar este artículo </v-card-title>
    		<v-card-text>
	    		<v-row>
			      <v-col cols="12" align-self="center">
						  <v-row align="center" justify="space-around">

						  	<!-- Card uno de la imagen -->
						  	<v-col cols="12" md="6" lg="4">
						  		<v-card outlined class=" mb-4">
				 						<!-- <lingallery :iid.sync="currentId" :height="50" :items="fotos2" class="white"/> -->
						  		  <v-img :src="url + fotoPrincipal" max-height="500" contain loading="lazy" class="white"  >
						  		  	<v-card-actions class="text-right" v-if="articuloAcotizar.pjedesc > 0">
				                <v-spacer></v-spacer>
				                <img :src="url + 'promo.png'" height="120"/>
				              </v-card-actions>
						  		  </v-img>
						  		</v-card>

						  		<!-- Minuaturas -->
				  		  	<v-row class="pl-3">
				  		    	<v-col cols="4" md="4" lg="3" class="pl-0" v-for="(foto, i) in fotos" :key="i">
				  		    		<v-card outlined class="" height="100" @click="fotoPrincipal = foto.image_name">
				  		    			<v-img :src="url + foto.image_name"  height="100" contain aspect-ratio="2" loading="lazy" class="white"></v-img>
				  		    		</v-card>
				  		    	</v-col>
				  		  	</v-row>
						  	</v-col>

						  	<!-- columna de información -->
						  	<v-col cols="12" md="6" lg="7" xl="4">
						  		<v-card class="elevation-0 transparent">
						        <v-card  class="text-h5 font-weight-bold textocolor--text elevation-0 transparent"> 
						        	{{ articuloAcotizar.nomart }}
						        </v-card>

									  <!-- SKU -->
									  <div class="grey--text mt-2" v-if="articuloAcotizar">SKU: {{ articuloAcotizar.codigo }}</div>


									  <br/>

									  <div >

									  	<v-row>
									  		<v-col cols="12">
									  			<v-tabs
											      background-color="primary"
											      center-active
											      v-model="tab"
											    >
											      <v-tab v-for="( catego , i ) in categorias" :key="i">{{ catego.categoria }}</v-tab>
											    </v-tabs>
										      <v-tabs-items v-model="tab">
											      <v-tab-item
											        v-for="( catego , i ) in categorias" 
											        :key="i"
											      >
											        <v-card
											          color="basil"
											          flat
											        >
											          <v-card-text>
											          	<v-radio-group
															      v-model="catego.seleccion"
															      row
															    >
															      <v-radio
															      	v-for="(sub, j ) in catego.subcategorias"
															      	:key="j"
															        :label="sub.subcategoria"
															        :value="sub.idsubcategorias"
															      >
											          			<template v-slot:label>
																        <div class="text-center">
																          <strong>{{ sub.subcategoria }}</strong>
																          <v-img
																            :src="sub.foto ? ( url + sub.foto ) : ( url + 'sinfoto.jpg' )"
																            height="100"
																            width="100"
																            class="my-2"
																            :class="{
																              'selected-img': catego.seleccion === sub.idsubcategorias,
																              'unselected-img': catego.seleccion !== sub.idsubcategorias
																            }"
																            contain
																          />
																          <div class="grey--text">${{ sub.precio || 100 }}</div>
																        </div>
																      </template>
															    	</v-radio>
															    </v-radio-group>
											          </v-card-text>
											        </v-card>
											      </v-tab-item>
											    </v-tabs-items>
									  		</v-col>
									  	</v-row>
									  </div>

									  <!-- Precio del artículo con descuento -->
									  <div class="text-decoration-line-through " >
									  	<h3 v-if="articuloAcotizar.pjedesc > 0">
									  		<span style="font-size: 15px; color:red;" class="pl-2">$ {{ preciodesc }}</span>
									  		<span style="font-size: 10px; color:grey;" class="pl-2">MXN</span>
									  	</h3>
									  </div>

									  <!-- Precio normal del artículo -->
									  <div 
									  	class="text-h5 primary--text font-weight-black mt-6"
									  >
									  	<v-text-field
									  		v-model="cantidad"
									  		filled
									  		hide-details
									  		label="Cantidad"
									  		type="number"
									  	>
									  	</v-text-field>
									  </div>

									  <!-- Precio normal del artículo -->
									  <div 
									  	class="text-h5 primary--text font-weight-black mt-6"
									  >
									  	Total: ${{ precioFormat }}
									  	<span style="font-size: 15px;" class="primary--text">MXN</span>
									  </div>

									  <!-- Descripción -->
									  <div class=" text-subtitle-1 mt-6">{{ articuloAcotizar.descrip }}</div>

									  <!-- <div class="grey--text text-subtitle-1" v-html="articulo.descripLarga"></div> -->
									  <div 
									  	style="white-space: pre-line" 
									  	v-html="articuloAcotizar.descripLarga"
									  ></div>

									  <v-card-actions class="pl-0 pt-10">
									    <v-btn 
									    	style="border-radius: 0px;" 
									    	large
									    	color="primary"
									    	class="text-caption"
									    >
									    	<span style="font-size: 12px;" @click="agregar_a_carrito_dos()">Agregar al carrito <v-icon>mdi-cart-outline</v-icon></span> 
									  	</v-btn>
									  </v-card-actions>
						  		</v-card>
						  	</v-col>
						  </v-row>
						</v-col>
					</v-row>
    		</v-card-text>
    		<v-btn
    			color="black"
    			absolute
    			top
    			right
    			icon
    			@click="dialogCotizador = false"
    		>
    			<v-icon>mdi-close</v-icon>	
    		</v-btn>
    	</v-card>	
    </v-dialog>

    <v-dialog
    	v-model="dialogCarrito"
    	max-width="1000"
    >
    	<v-card>
    		<v-card-title> Cotizar este artículo </v-card-title>
    		<v-card-text>
	    		<v-row v-for="(art, i ) in carrito" :key="i">
			      <v-col cols="12" align-self="center">
						  <v-row align="center" justify="space-around">

						  	<!-- Card uno de la imagen -->
						  	<v-col cols="12" md="6" lg="4">
						  		<v-card outlined class=" mb-4">
				 						<!-- <lingallery :iid.sync="currentId" :height="50" :items="fotos2" class="white"/> -->
						  		  <v-img :src="url + art.foto" max-height="500" contain loading="lazy" class="white"  >
						  		  	<v-card-actions class="text-right" v-if="art.pjedesc > 0">
				                <v-spacer></v-spacer>
				                <img :src="url + 'promo.png'" height="120"/>
				              </v-card-actions>
						  		  </v-img>
						  		</v-card>
						  	</v-col>

						  	<!-- columna de información -->
						  	<v-col cols="12" md="6" lg="7" xl="4">
						  		<v-card class="elevation-0 transparent">
						        <v-card  class="text-h5 font-weight-bold textocolor--text elevation-0 transparent"> 
						        	{{ art.nomart }}
						        </v-card>

									  <!-- SKU -->
									  <div class="grey--text mt-2" v-if="art">SKU: {{ art.codigo }}</div>


									  <br/>

									  <div v-for="( catego , i ) in art.detalles" :key="i">
									    <b>{{ catego.categoria }}:</b> {{ catego.subcategoria }}
									  </div>

									  <!-- Precio del artículo con descuento -->
									  <div class="text-decoration-line-through " >
									  	<h3 v-if="art.pjedesc > 0">
									  		<span style="font-size: 15px; color:red;" class="pl-2">$ {{ art.precioFinalFormat }}</span>
									  		<span style="font-size: 10px; color:grey;" class="pl-2">MXN</span>
									  	</h3>
									  </div>

									  <!-- Precio normal del artículo -->
									  <div 
									  	class="text-h5 primary--text font-weight-black mt-6"
									  >
									  	<v-text-field
									  		v-model="art.cantidad"
									  		filled
									  		hide-details
									  		label="Cantidad"
									  		readonly
									  		type="number"
									  	>
									  	</v-text-field>
									  </div>

									  <!-- Precio normal del artículo -->
									  <div 
									  	class="text-h5 primary--text font-weight-black mt-6"
									  >
									  	Total: ${{ art.precioFinalFormat }}
									  	<span style="font-size: 15px;" class="primary--text">MXN</span>
									  </div>

									  <!-- Descripción -->
									  <div class=" text-subtitle-1 mt-6">{{ art.descrip }}</div>

									  <!-- <div class="grey--text text-subtitle-1" v-html="articulo.descripLarga"></div> -->
									  <div 
									  	style="white-space: pre-line" 
									  	v-html="art.descripLarga"
									  ></div>
									  
						  		</v-card>
						  	</v-col>
						  </v-row>
						</v-col>

						<v-divider class="my-4"></v-divider>
					</v-row>

					<v-row>
						<v-col cols="12">

							<div 
						  	class="text-h4 primary--text font-weight-black mt-6"
						  >
						  	Total a pagar:</b> ${{ costoTotal }}
						  	<span style="font-size: 15px;" class="primary--text">MXN</span>
						  </div>
						</v-col>

						<v-col cols="12">
							<v-btn
								block
								color="primary"
							>
								Terminar cotización
							</v-btn>
						</v-col>
					</v-row>
    		</v-card-text>
    	</v-card>	
    </v-dialog>

  </v-main>
</template>

<script>
  import Vue from 'vue'
  import  metodos from '@/mixins/metodos.js';

  const accounting = require("accounting");


	import {mapGetters, mapActions} from 'vuex'
  
  export default {
    mixins:[metodos],
    components: {
		},
    data: () => ({
      page: 0,
      pageCount: 0,
      itemsPerPage: 100,
      search:'',
      pedidos:[],

      nombre:'',
      apellido:'', 
      email:'', 
      telefono:'',

      alerta: { activo: false, texto:'', color:'error' },
      loading: false,

      url   : '',

      dialogCotizador: false,
      articuloAcotizar: null,
      fotoPrincipal: '',
			activo: 0,
			fotos:[],
			fotos2:[],
			preciodesc:0,

			categorias:[],

			cantidad: 1,
			carrito:[],

			dialogCarrito: false,
			tab: null,
			calle: '',
			numint: '',
			cp: '',
			colonia: '',
			estado: '',

    }),

    computed: {
      ...mapGetters('Login',['getusuarioFetish']),

      precioFormat( ){

      	let precioFinal = 0


      	let mapIds = this.categorias.filter( el => el.seleccion ).map((registro) => { return registro.seleccion })

      	let subs = []

      	for( const i in this.categorias ){

      		subs = subs.concat( this.categorias[i].subcategorias )

      	}

      	let detallesSeleccionados = subs.filter( el => mapIds.includes( el.idsubcategorias ))


      	let otrosPrecios = detallesSeleccionados.map(item => item.precio  ).reduce((prev, curr) => prev + curr, 0)


      	if(this.articuloAcotizar.pjedesc > 0 ){
					this.preciodesc = this.articuloAcotizar.precio1 * (  (100 - this.articuloAcotizar.pjedesc) * 0.01 ) 
					precioFinal = ( this.preciodesc + otrosPrecios )  * this.cantidad
				}else{
					precioFinal = ( this.articuloAcotizar.precio1 + otrosPrecios )  * this.cantidad
				}

				this.articuloAcotizar['detalles']    = detallesSeleccionados
				this.articuloAcotizar['precioFinal'] = precioFinal
				this.articuloAcotizar['precioFinalFormat'] = accounting.formatNumber(  precioFinal, 2 )
				this.articuloAcotizar['foto']        = this.fotoPrincipal
				this.articuloAcotizar['cantidad']    = this.cantidad

				return  accounting.formatNumber( precioFinal, 2 )
      },


      costoTotal( ){

      	let otrosPrecios = this.carrito.map(item => item.precioFinal  ).reduce((prev, curr) => prev + curr, 0)

				return  accounting.formatNumber( otrosPrecios, 2 )

      }
    },


    watch: {

    },

    filters:{
      currency(val, dec){
        return accounting.formatMoney(val, '$', dec)
      }
    },

    created () {
    	this.url = this.$http.options.root + 'fotos-epic-grass/' 
      this.initialize( );
      this.getCategorias( )
    },

    methods: {
      initialize () {

        this.$http.get('obtener.articulos').then( response =>{
          console.log(response.body)
          this.pedidos = response.body
        }).catch( error =>{
          console.log('error', error)
        }).finally(()=>{ this.loading = false})
      },

      getCategorias () {
        this.categorias = []
        this.$http.get('categorias.all').then(response =>{
          if(response == null){
            this.loading = false
            this.productos = []
          }else{
            this.loading = false
            this.categorias = response.body

            this.categorias.forEach(element=>{
              element.estatus == 1 ? true:false
            })
          }
        })
      },


      async cotizaArticulo( item ){

      	await this.dataArticulo( item )
      	await this.fotoArticulo( item )

      },

	    dataArticulo( item ){

	    	return this.$http.get('tienda/articulos.articulo/' + item.id).then(response=>{

	  			this.articuloAcotizar = response.body

	  			this.activo = this.articuloAcotizar.estatus == 1 ? true : false

					if(this.articuloAcotizar.pjedesc > 0 ){
						this.preciodesc = this.articuloAcotizar.precio1 * (  (100 - this.articuloAcotizar.pjedesc) * 0.01 ) 
						this.preciodesc = accounting.formatNumber(this.articuloAcotizar.precio1,2)
					}else{
						this.preciodesc = accounting.formatNumber(this.preciodesc,2)
					}

					this.dialogCotizador  = true 
	  			
	  		}).catch(error=>{console.log(error)})
	    },

			fotoArticulo( ){
				this.$http.get('tienda/articulos/fotos/' + this.articuloAcotizar.codigo).then(response=>{

    			this.fotos = response.body

    			const foto = response.body.find(foto => foto.principal == 1)

    			if(foto){
    				this.fotoPrincipal = foto.image_name
    			}else if(response.body.length > 0){
    				this.fotoPrincipal = response.body[0].image_name
    			} 

    			let foto2 = {}

    			for(const i in this.fotos){
    				foto2 = {
    					id: this.fotos[i].idfotos,
    					src: this.url + this.fotos[i].image_name,
    					thumbnail: this.url + this.fotos[i].image_name,
    					alt:'',
    					caption:''
    				}
    				this.fotos2.push(foto2)
    			}


    			return
    		}).catch(error=>{console.log(error)})
			},

			agregar_a_carrito_dos( ){


				this.carrito.push( this.articuloAcotizar )
				
				this.dialogCotizador = false

			}



    },


    finalizarProceso(){
        this.initialize();
      }
  }
</script>

<style scoped>
  .normal{
    text-transform: none;
  }
</style>